/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/conversion-tracking.js":
/*!***************************************!*\
  !*** ./src/js/conversion-tracking.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initConversionTracking)
/* harmony export */ });
var _excluded = ["event"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Conversion tracking: emits `form_submit` / `generate_lead` for Contact, Make An
 * Appointment, Get Directions (stores map and showroom pages) and the quote request.
 * Each goes to `window.dataLayer` and, as a Shopify custom event, to web pixels
 * (`analytics.subscribe(name)` → `event.customData`). Emits only — tag config is
 * in a Custom Pixel; keep event names in step with third-party/shopify-pixels/.
 *
 * QA: `localStorage.setItem('te:conversion-tracking:debug', '1')` logs every push.
 */

/**
 * @typedef {Object} HulkForm
 * @property {string} form_id - dataLayer form_id.
 * @property {string} form_name - dataLayer form_name.
 */

/**
 * One `quotes[N]` entry from Samita's submit body.
 *
 * @typedef {Object} QuoteLine
 * @property {string} [sku]
 * @property {string} [name]
 * @property {string} [vendor]
 * @property {string} [variant_name]
 * @property {number|string} [variant_id]
 * @property {string} [product_url]
 * @property {number|string} [qty]
 */

/**
 * The fields we read from `/products/{handle}.js`.
 *
 * @typedef {Object} ShopifyProduct
 * @property {string} type
 * @property {Array<string>} tags
 * @property {Array<{name: string}>} options
 * @property {Array<{id: number, options: Array<string>}>} variants
 */

/**
 * @typedef {Object} DataLayerItem
 * @property {string} item_id
 * @property {string} item_name
 * @property {string} item_brand
 * @property {string} item_category
 * @property {string} item_category2
 * @property {string} item_variant
 * @property {string} item_color
 * @property {string} item_size
 * @property {number} quantity
 */

/**
 * @typedef {Window & {
 *     dataLayer?: Array<Object>,
 *     Shopify?: {analytics?: {publish?: function(string, Object<string, *>): void}}
 * }} TrackingHost
 */

/** @type {string} */
var HULK_ORIGIN = 'https://formbuilder.hulkapps.com';

/**
 * Posted by our Hulk Custom JS (third-party/hulk-forms/) on load and on store change.
 *
 * @type {string}
 */
var SNAPSHOT_MESSAGE_TYPE = 'tb_form_field_snapshot';

/**
 * Hulk's own submit message; carries `{form_id, email, timestamp}`, no field values.
 *
 * @type {string}
 */
var SUBMITTED_MESSAGE_TYPE = 'form_submitted';

/** @type {string} */
var FORM_DESTINATION = 'www.tileempire.com.au';

/**
 * Hulk form uuid → dataLayer identity.
 *
 * @type {Object<string, HulkForm>}
 */
var HULK_FORMS = {
  'Jy762wrAflAdXagsgIIvPg': {
    form_id: 'contact-us-body',
    form_name: 'Contact'
  },
  'HH97ZsMPudbWlPRrRCuWEQ': {
    form_id: 'appointment-body',
    form_name: 'Make An Appointment'
  }
};

/**
 * Uppercased store name → name we emit. Hulk sends title case; Storeify and Samita
 * send uppercase.
 *
 * @type {Object<string, string>}
 */
var CANONICAL_STORES = {
  'JOONDALUP': 'Joondalup',
  'PORT HEDLAND': 'Port Hedland',
  'KARRATHA': 'Karratha',
  'GERALDTON': 'Geraldton',
  'OSBORNE PARK': 'Osborne Park',
  'MIDLAND': 'Midland',
  'MANDURAH': 'Mandurah',
  'BUNBURY': 'Bunbury',
  'MYAREE': 'Myaree'
};

/**
 * @typedef {Object} DirectionsLink
 * @property {string} link - The directions anchor.
 * @property {string} container - Its ancestor that holds the store name.
 * @property {string} name - The store name, inside the container.
 * @property {string} location - dataLayer form_location.
 */

/**
 * Storeify directions links; the first whose container matches wins. On
 * /pages/stores they sit on list cards and in the map's info-window popup
 * (`.store-name` is a `<label><strong>` on cards, a `<p>` in the popup). Showroom
 * detail pages have the app's address link and our pill (store-locator-title.liquid).
 *
 * @type {Array<DirectionsLink>}
 */
var DIRECTIONS_LINKS = [{
  link: 'a.getdirectionstore',
  container: '.inner-item',
  name: '.store-name',
  location: 'Map List'
}, {
  link: 'a.getdirectionstore',
  container: '.store-marker',
  name: '.store-name',
  location: 'Map Popup'
}, {
  link: 'a.te-store__directions',
  container: '.storeify-sl-details',
  name: '.header-store-name',
  location: 'Store Detail'
}, {
  link: 'a.entry-item-address-link',
  container: '.storeify-sl-details',
  name: '.header-store-name',
  location: 'Store Detail Address'
}];

/** @type {string} */
var QUOTE_SUBMIT_URL = 'https://quote.samita.io/app/submit';

/**
 * Samita's admin-generated Preferred Store field; changes if the field is recreated.
 *
 * @type {string}
 */
var QUOTE_STORE_FIELD = 'additional_data[select__1759295820816]';

/** @type {RegExp} */
var QUOTE_LINE_KEY = /^quotes\[\d+\]$/;

/**
 * Pulls the handle from a quote line's `product_url`.
 *
 * @type {RegExp}
 */
var PRODUCT_PATH = /\/products\/([^/]+)/;

/**
 * The "Aesthetic - …" collections are built from these tags, so the tags stand
 * in for the product's collections.
 *
 * @type {string}
 */
var AESTHETIC_TAG_PREFIX = 'aesthetic:';

/**
 * Option names vary in case and order across products ("Colour", "colour", "Color").
 *
 * @type {RegExp}
 */
var COLOR_OPTION = /^colou?r$/i;

/** @type {RegExp} */
var SIZE_OPTION = /^size$/i;

/**
 * After this, the quote push goes ahead with its lookup fields empty.
 *
 * @type {number}
 */
var PRODUCT_LOOKUP_TIMEOUT_MS = 3000;

/** @type {string} */
var DEBUG_KEY = 'te:conversion-tracking:debug';

/**
 * Listens for the four conversions and pushes each to the dataLayer.
 */
var ConversionTracker = /*#__PURE__*/function () {
  function ConversionTracker() {
    _classCallCheck(this, ConversionTracker);
    /**
     * Latest preferred store per Hulk form uuid.
     * @type {Map<string, string>}
     */
    this.snapshots = new Map();

    /**
     * Product lookups per handle; a failed lookup resolves to null.
     * @type {Map<string, Promise<?ShopifyProduct>>}
     */
    this.products = new Map();
  }

  /**
   * Binds every listener. Call at script run, not on DOMContentLoaded, so an
   * early Hulk snapshot and Samita's first fetch aren't missed.
   */
  return _createClass(ConversionTracker, [{
    key: "start",
    value: function start() {
      var _this = this;
      window.addEventListener('message', function (event) {
        return _this.onMessage(event);
      });
      // Capture on window: custom-showrooms.liquid stops propagation at document.
      window.addEventListener('click', function (event) {
        return _this.onDirectionsClick(event);
      }, true);
      this.wrapFetch();
    }

    /**
     * Caches Hulk store snapshots and pushes on Hulk's submit message.
     *
     * @param {MessageEvent} event
     */
  }, {
    key: "onMessage",
    value: function onMessage(event) {
      var isHulk = event.origin === HULK_ORIGIN && event.data !== null && _typeof(event.data) === 'object';
      var type = isHulk ? event.data.type : '';
      var payload = isHulk && event.data.payload || {};
      var formId = typeof payload.form_id === 'string' ? payload.form_id : '';
      if (type === SNAPSHOT_MESSAGE_TYPE) {
        this.snapshots.set(formId, typeof payload.preferred_store === 'string' ? payload.preferred_store : '');
      } else if (type === SUBMITTED_MESSAGE_TYPE) {
        this.pushHulkSubmit(formId);
      }
    }

    /**
     * Pushes a Hulk submit for a mapped form; other Hulk forms are ignored.
     *
     * @param {string} formId - Hulk form uuid.
     */
  }, {
    key: "pushHulkSubmit",
    value: function pushHulkSubmit(formId) {
      var form = HULK_FORMS[formId];
      if (form) {
        this.push({
          event: 'form_submit',
          form_id: form.form_id,
          form_name: form.form_name,
          preferred_store: this.normalizeStoreName(this.snapshots.get(formId)),
          form_location: 'Body',
          form_destination: FORM_DESTINATION
        });
      } else {
        this.log('ignored unmapped Hulk form', formId);
      }
    }

    /**
     * Pushes a "Get Directions" click from the stores map or a showroom detail page.
     *
     * @param {MouseEvent} event
     */
  }, {
    key: "onDirectionsClick",
    value: function onDirectionsClick(event) {
      var target = event.target instanceof Element ? event.target : null;
      var hit = target ? this.directionsHit(target) : null;
      var nameEl = hit && hit.container ? hit.container.querySelector(hit.source.name) : null;
      var rawName = nameEl ? (nameEl.textContent || '').trim() : '';
      if (hit && !rawName) {
        console.warn('ConversionTracker: no store name beside directions link; Storeify markup may have changed');
      }
      if (hit) {
        this.push({
          event: 'form_submit',
          form_id: 'stores-map-list',
          form_name: 'Get Directions',
          store_name: this.normalizeStoreName(rawName),
          form_location: hit.source.location,
          form_destination: FORM_DESTINATION
        });
      }
    }

    /**
     * Falls back to the first link match without a container, so a markup change
     * still pushes, with the store name empty.
     *
     * @param {Element} target - The clicked element.
     * @returns {?{source: DirectionsLink, container: ?Element}} The matched link, or null.
     */
  }, {
    key: "directionsHit",
    value: function directionsHit(target) {
      var hits = DIRECTIONS_LINKS.map(function (source) {
        return {
          source: source,
          link: target.closest(source.link)
        };
      }).filter(function (hit) {
        return hit.link !== null;
      }).map(function (hit) {
        return {
          source: hit.source,
          container: hit.link ? hit.link.closest(hit.source.container) : null
        };
      });
      return hits.find(function (hit) {
        return hit.container !== null;
      }) || hits[0] || null;
    }

    /**
     * Wraps `window.fetch` to spot Samita's quote submit. The caller always gets
     * the original promise; the push runs on a side branch.
     */
  }, {
    key: "wrapFetch",
    value: function wrapFetch() {
      var _this2 = this;
      var originalFetch = window.fetch;
      if (typeof originalFetch === 'function') {
        /** @type {typeof window.fetch} */
        var wrapped = function wrapped() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var result = originalFetch.apply(window, args);
          var body = args[1] ? args[1].body : null;
          if (body instanceof FormData && _this2.isQuoteSubmit(args[0])) {
            result.then(function (response) {
              return _this2.onQuoteResponse(response, body);
            })["catch"](function () {});
          }
          return result;
        };
        window.fetch = wrapped;
      }
    }

    /**
     * @param {RequestInfo|URL} input - fetch's first argument.
     * @returns {boolean} True for Samita's submit endpoint.
     */
  }, {
    key: "isQuoteSubmit",
    value: function isQuoteSubmit(input) {
      var raw = typeof input === 'string' ? input : input instanceof URL ? input.href : input instanceof Request ? input.url : '';
      var matches = false;
      try {
        var url = new URL(raw, window.location.href);
        matches = url.origin + url.pathname === QUOTE_SUBMIT_URL;
      } catch (error) {
        matches = false;
      }
      return matches;
    }

    /**
     * @param {Response} response
     * @param {FormData} formData - The submitted request body.
     * @returns {Promise<void>}
     */
  }, {
    key: "onQuoteResponse",
    value: function onQuoteResponse(response, formData) {
      return response.ok ? this.pushQuoteSubmit(formData) : Promise.resolve();
    }

    /**
     * Pushes once every line's product lookup has settled.
     *
     * @param {FormData} formData - Samita's submit body.
     * @returns {Promise<void>}
     */
  }, {
    key: "pushQuoteSubmit",
    value: function pushQuoteSubmit(formData) {
      var _this3 = this;
      var rawStore = formData.get(QUOTE_STORE_FIELD);
      var lines = this.quoteLines(formData);
      return Promise.all(lines.map(function (line) {
        return _this3.productFor(line);
      })).then(function (products) {
        return _this3.push({
          event: 'generate_lead',
          form_id: 'quote-sidebar',
          form_name: 'Quote Request',
          preferred_store: _this3.normalizeStoreName(typeof rawStore === 'string' ? rawStore : ''),
          form_location: 'Sidebar',
          form_destination: FORM_DESTINATION,
          ecommerce: {
            items: lines.map(function (line, index) {
              return _this3.toItem(line, products[index]);
            })
          }
        });
      });
    }

    /**
     * @param {FormData} formData
     * @returns {Array<QuoteLine>} Every parseable `quotes[N]` entry.
     */
  }, {
    key: "quoteLines",
    value: function quoteLines(formData) {
      var _this4 = this;
      return Array.from(formData.entries()).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return QUOTE_LINE_KEY.test(key) && typeof value === 'string';
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          value = _ref4[1];
        return _this4.parseQuoteLine(/** @type {string} */value);
      }).filter(function (line) {
        return line !== null;
      }).map(function (line) {
        return /** @type {QuoteLine} */line;
      });
    }

    /**
     * @param {QuoteLine} line
     * @returns {Promise<?ShopifyProduct>} The line's product, or null if the lookup fails.
     */
  }, {
    key: "productFor",
    value: function productFor(line) {
      var handle = this.productHandle(line.product_url);
      var product = this.products.get(handle);
      if (!product) {
        product = handle ? this.fetchProduct(handle) : Promise.resolve(null);
        this.products.set(handle, product);
      }
      return product;
    }

    /**
     * @param {string|undefined} url - A quote line's `product_url`.
     * @returns {string} The product handle, or '' if there isn't one.
     */
  }, {
    key: "productHandle",
    value: function productHandle(url) {
      var handle = '';
      try {
        var match = new URL(url || '', window.location.href).pathname.match(PRODUCT_PATH);
        handle = match ? match[1] : '';
      } catch (error) {
        handle = '';
      }
      return handle;
    }

    /**
     * @param {string} handle
     * @returns {Promise<?ShopifyProduct>} Null on error, non-2xx or timeout.
     */
  }, {
    key: "fetchProduct",
    value: function fetchProduct(handle) {
      var controller = new AbortController();
      /** @type {ReturnType<typeof setTimeout>} */
      var timer = setTimeout(function () {
        return controller.abort();
      }, PRODUCT_LOOKUP_TIMEOUT_MS);
      return window.fetch("/products/".concat(handle, ".js"), {
        signal: controller.signal
      }).then(function (response) {
        return response.ok ? response.json() : Promise.reject(new Error("HTTP ".concat(response.status)));
      })["catch"](function (error) {
        console.warn('ConversionTracker: product lookup failed for', handle, error);
        return null;
      })["finally"](function () {
        return clearTimeout(timer);
      });
    }

    /**
     * @param {string} json
     * @returns {?QuoteLine} Null when the JSON doesn't parse.
     */
  }, {
    key: "parseQuoteLine",
    value: function parseQuoteLine(json) {
      var line = null;
      try {
        line = JSON.parse(json);
      } catch (error) {
        console.warn('ConversionTracker: unreadable quote line', error);
      }
      return line;
    }

    /**
     * Category is the product type, category2 its aesthetics. Colour and size are
     * read from the variant's named options. All four are empty without a product.
     *
     * @param {QuoteLine} line
     * @param {?ShopifyProduct} product
     * @returns {DataLayerItem}
     */
  }, {
    key: "toItem",
    value: function toItem(line, product) {
      var variant = product ? product.variants.find(function (candidate) {
        return String(candidate.id) === String(line.variant_id);
      }) : undefined;
      return {
        item_id: line.sku || '',
        item_name: line.name || '',
        item_brand: line.vendor || '',
        item_category: product ? (product.type || '').trim() : '',
        item_category2: product ? this.aesthetics(product) : '',
        item_variant: line.variant_name || '',
        item_color: this.optionValue(product, variant, COLOR_OPTION),
        item_size: this.optionValue(product, variant, SIZE_OPTION),
        quantity: Number(line.qty) || 0
      };
    }

    /**
     * @param {ShopifyProduct} product
     * @returns {string} The `aesthetic:` tags, comma-joined ("Brick, Stone").
     */
  }, {
    key: "aesthetics",
    value: function aesthetics(product) {
      return product.tags.filter(function (tag) {
        return tag.startsWith(AESTHETIC_TAG_PREFIX);
      }).map(function (tag) {
        return tag.slice(AESTHETIC_TAG_PREFIX.length).trim();
      }).join(', ');
    }

    /**
     * @param {?ShopifyProduct} product
     * @param {{options: Array<string>}|undefined} variant
     * @param {RegExp} name - Matches the option's name.
     * @returns {string} The variant's value for that option, or ''.
     */
  }, {
    key: "optionValue",
    value: function optionValue(product, variant, name) {
      var index = product ? product.options.findIndex(function (option) {
        return name.test(option.name.trim());
      }) : -1;
      return variant && index >= 0 && variant.options[index] || '';
    }

    /**
     * @param {string|undefined} raw - Store name in any case.
     * @returns {string} Canonical title-case name, or '' if unknown.
     */
  }, {
    key: "normalizeStoreName",
    value: function normalizeStoreName(raw) {
      var key = (raw || '').trim().replace(/\s+/g, ' ').toUpperCase();
      var canonical = CANONICAL_STORES[key] || '';
      if (key && !canonical) {
        console.warn('ConversionTracker: unrecognised store name', JSON.stringify(raw));
      }
      return canonical;
    }

    /**
     * Pushes to the dataLayer and publishes the same fields, minus `event`, as a
     * Shopify custom event named after it.
     *
     * @param {Object<string, *>} data - One dataLayer event.
     */
  }, {
    key: "push",
    value: function push(data) {
      var host = /** @type {TrackingHost} */window;
      var event = data.event,
        fields = _objectWithoutProperties(data, _excluded);
      var analytics = host.Shopify ? host.Shopify.analytics : undefined;
      host.dataLayer = host.dataLayer || [];
      host.dataLayer.push(data);
      if (analytics && typeof analytics.publish === 'function') {
        analytics.publish(String(event), fields);
      } else {
        console.warn('ConversionTracker: Shopify.analytics.publish unavailable; web pixels miss', event);
      }
      this.log('push', data);
    }

    /**
     * Console log, only when the debug flag is set.
     *
     * @param {...*} args
     */
  }, {
    key: "log",
    value: function log() {
      var enabled = false;
      try {
        enabled = window.localStorage.getItem(DEBUG_KEY) === '1';
      } catch (error) {
        enabled = false;
      }
      if (enabled) {
        var _console;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_console = console).log.apply(_console, ['[ConversionTracker]'].concat(args));
      }
    }
  }]);
}();
/**
 * Starts conversion tracking. Call once, at script run.
 */
function initConversionTracking() {
  new ConversionTracker().start();
}

/***/ }),

/***/ "./src/js/custom.js":
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _hero_zoom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./hero-zoom */ "./src/js/hero-zoom.js");
/* harmony import */ var _rail__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./rail */ "./src/js/rail.js");
/* harmony import */ var _reveal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reveal */ "./src/js/reveal.js");
/* harmony import */ var _load_more_count__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./load-more-count */ "./src/js/load-more-count.js");
/* harmony import */ var _pdp_media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./pdp-media */ "./src/js/pdp-media.js");
/* harmony import */ var _pdp_stock__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./pdp-stock */ "./src/js/pdp-stock.js");
/* harmony import */ var _project_count__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./project-count */ "./src/js/project-count.js");
/* harmony import */ var _project_gallery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./project-gallery */ "./src/js/project-gallery.js");
/* harmony import */ var _quick_view_media__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./quick-view-media */ "./src/js/quick-view-media.js");
/* harmony import */ var _showrooms_recall__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./showrooms-recall */ "./src/js/showrooms-recall.js");
/* harmony import */ var _quick_view_reopen__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./quick-view-reopen */ "./src/js/quick-view-reopen.js");
/* harmony import */ var _quote_add__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./quote-add */ "./src/js/quote-add.js");
/* harmony import */ var _quote_page__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./quote-page */ "./src/js/quote-page.js");
/* harmony import */ var _quote_unlock__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./quote-unlock */ "./src/js/quote-unlock.js");
/* harmony import */ var _statement_drift__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./statement-drift */ "./src/js/statement-drift.js");
/* harmony import */ var _video_gallery__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./video-gallery */ "./src/js/video-gallery.js");
/* harmony import */ var _conversion_tracking__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./conversion-tracking */ "./src/js/conversion-tracking.js");
/**
 * Custom theme JavaScript — entry point.
 * Compiled by Laravel Mix to theme/assets/custom.js.
 *
 * To load it in the theme, add to theme/layout/theme.liquid:
 *   <script src="{{ 'custom.js' | asset_url }}" defer></script>
 *
 * Conventions: bind to the theme's existing `.js-*` hooks; keep styling in
 * src/scss, not here. Import feature modules into this entry as they're added.
 */


















// At script run, not on DOMContentLoaded, so early Hulk messages and Samita's fetch are caught.
(0,_conversion_tracking__WEBPACK_IMPORTED_MODULE_16__["default"])();
document.addEventListener('DOMContentLoaded', function () {
  (0,_hero_zoom__WEBPACK_IMPORTED_MODULE_0__["default"])();
  (0,_rail__WEBPACK_IMPORTED_MODULE_1__["default"])();
  (0,_reveal__WEBPACK_IMPORTED_MODULE_2__["default"])();
  (0,_load_more_count__WEBPACK_IMPORTED_MODULE_3__["default"])();
  (0,_pdp_media__WEBPACK_IMPORTED_MODULE_4__["default"])();
  (0,_pdp_stock__WEBPACK_IMPORTED_MODULE_5__["default"])();
  (0,_project_count__WEBPACK_IMPORTED_MODULE_6__["default"])();
  (0,_project_gallery__WEBPACK_IMPORTED_MODULE_7__["default"])();
  (0,_quick_view_media__WEBPACK_IMPORTED_MODULE_8__["default"])();
  (0,_showrooms_recall__WEBPACK_IMPORTED_MODULE_9__["default"])();
  (0,_quick_view_reopen__WEBPACK_IMPORTED_MODULE_10__["default"])();
  (0,_quote_add__WEBPACK_IMPORTED_MODULE_11__["default"])();
  (0,_quote_page__WEBPACK_IMPORTED_MODULE_12__["default"])();
  (0,_quote_unlock__WEBPACK_IMPORTED_MODULE_13__["default"])();
  (0,_statement_drift__WEBPACK_IMPORTED_MODULE_14__["default"])();
  (0,_video_gallery__WEBPACK_IMPORTED_MODULE_15__["default"])();
});

/***/ }),

/***/ "./src/js/hero-zoom.js":
/*!*****************************!*\
  !*** ./src/js/hero-zoom.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initHeroZoom)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Hero zoom — eases the hero image up in scale as the section scrolls away,
 * so the copy in front of it reads with a little depth.
 *
 * Written against scroll position rather than a CSS scroll-driven animation:
 * `animation-timeline` still is not universal, and the fallback for a browser
 * without it would be no effect at all rather than a lesser one.
 *
 * The scale is published as a CSS custom property and applied in _hero.scss —
 * the transform stays in the stylesheet, per the entry point's conventions.
 */
var SELECTOR = '.js-hero-zoom';
var SCALE_RANGE = 0.12; // 1.00 at rest, 1.12 once fully scrolled past
var HeroZoom = /*#__PURE__*/function () {
  function HeroZoom(image) {
    _classCallCheck(this, HeroZoom);
    this.image = image;
    this.hero = image.closest('.hero') || image.parentElement;
    this.queued = false;
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);
  }
  return _createClass(HeroZoom, [{
    key: "start",
    value: function start() {
      window.addEventListener('scroll', this.onScroll, {
        passive: true
      });
      window.addEventListener('resize', this.onScroll, {
        passive: true
      });
      this.update();
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      // Coalesce a burst of scroll events into one write per frame.
      if (!this.queued) {
        this.queued = true;
        window.requestAnimationFrame(this.update);
      }
    }
  }, {
    key: "update",
    value: function update() {
      this.queued = false;
      var height = this.hero.offsetHeight;
      var travelled = -this.hero.getBoundingClientRect().top;
      var progress = Math.min(Math.max(travelled / height, 0), 1);
      this.image.style.setProperty('--hero-zoom', (1 + progress * SCALE_RANGE).toFixed(4));
    }
  }]);
}();
function initHeroZoom() {
  var image = document.querySelector(SELECTOR);
  var stillness = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (image && !stillness.matches) {
    new HeroZoom(image).start();
  }
}

/***/ }),

/***/ "./src/js/load-more-count.js":
/*!***********************************!*\
  !*** ./src/js/load-more-count.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initLoadMoreCount)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * "Showing 18 of 78 tiles" — kept true as pages are appended.
 *
 * The theme's load-more appends into the grid and updates its own next-url; it
 * knows nothing about this line. Rather than track page numbers, the count is
 * read off the DOM — the items that exist ARE the items shown, which stays right
 * however they arrived (load more, a filter change that re-renders the grid, or
 * a browser restoring a longer list on back).
 *
 * The copy stays in the locale file: Liquid renders it once with placeholders
 * into `data-template`, and this only ever substitutes numbers.
 *
 * THE MARKUP SAYS WHAT TO COUNT. The category page and the news archive have
 * different grids and different words for what is in them, so each label names
 * its own grid and item selector rather than this holding a list of pages it has
 * to be told about (Adam, 2026-08-25).
 */
var LABEL = '.js-load-more-count';
var LoadMoreCount = /*#__PURE__*/function () {
  function LoadMoreCount(label) {
    _classCallCheck(this, LoadMoreCount);
    this.label = label;
    this.grid = document.querySelector(label.dataset.countGrid);
    this.item = label.dataset.countItem;
    this.template = label.dataset.template || '';
    this.total = label.dataset.total || '0';
  }
  return _createClass(LoadMoreCount, [{
    key: "valid",
    get: function get() {
      return Boolean(this.grid && this.item);
    }
  }, {
    key: "render",
    value: function render() {
      var shown = this.grid.querySelectorAll(this.item).length;
      var next = this.template.replace('__count__', shown).replace('__total__', this.total);
      if (this.label.textContent.trim() !== next) {
        this.label.textContent = next;
      }
    }
  }, {
    key: "watch",
    value: function watch() {
      var _this = this;
      // childList only, and not subtree: an item arriving is a direct child, and
      // watching the subtree would fire on every image that finishes decoding.
      new MutationObserver(function () {
        return _this.render();
      }).observe(this.grid, {
        childList: true
      });
      this.render();
    }
  }]);
}();
function initLoadMoreCount() {
  document.querySelectorAll(LABEL).forEach(function (label) {
    var count = new LoadMoreCount(label);
    if (count.valid) {
      count.watch();
    }
  });
}

/***/ }),

/***/ "./src/js/pdp-media.js":
/*!*****************************!*\
  !*** ./src/js/pdp-media.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initPdpMedia)
/* harmony export */ });
/* harmony import */ var _variant_options__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./variant-options */ "./src/js/variant-options.js");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Choosing a colour on the product page brings its photograph into view.
 *
 * The same behaviour as the quick view's, against a different gallery: the PDP's
 * media is a column in the PAGE's own scroll rather than its own scrollport, so
 * this scrolls the window and not a container.
 *
 * The mapping is the THEME's, not ours. Each slide already carries
 * `data-variant-id="id,id,…"` listing every variant that claims that image —
 * built in snippets/product-media.liquid — so there is no id-space guessing here,
 * unlike the quick view where the slides advertise a media id and an image id and
 * the variant JSON has to be reconciled against both.
 *
 * Offset by the header, which is sticky: scrolling an element to the top of the
 * viewport would otherwise put it under the bar. The offset is direction-aware,
 * because the header only exists in one of the two directions — see offsetOf.
 */

var FORM = '.product-form';
var JSON_SCRIPT = '[data-js-product-json]';
var SLIDE_VARIANTS = '.js-product-media-item-variant';
var SLIDE = '.js-product-media-item';
var HEADER = '.header-section';

// The base theme's scroll-direction module ignores a move of 5px or less, so a
// shorter rise never reveals the header and must not reserve room for it.
var RISE_THRESHOLD = 5;

// MEASURED, not read from a token. The bar is 152 tall on desktop and 88 on
// mobile, that number has moved more than once, and a collapsed header still
// reports its full height because the base theme moves it on `top` rather than
// collapsing its box — so the measurement is right whichever state it is in at
// the moment of the click.
function headerReserve() {
  var header = document.querySelector(HEADER);
  return header ? header.getBoundingClientRect().height : 0;
}

// The photograph comes to rest level with the top of the sticky info column —
// the same 56 buffer, read from the same token. Aligning it to the viewport's top
// would put it under the header when the header is showing, and aligning it to the
// document top is not what "bring this image up" means at all.
//
// AND 56 IS ONLY RIGHT GOING DOWN. The header is `sticky_hide` (see
// src/scss/_header.scss): it collapses on the way down and drops back in on the
// way up. So a downward anchor has nothing to clear and 56 is the whole story,
// while an upward one arrives to a full-height bar landing on top of the image —
// burying the first 40px of it, which is exactly where the caption pill sits
// (Adam, 2026-09-11). Reserving the header both ways was the wrong trade: it
// would leave every downward anchor a header's height of empty room.
//
// Under the threshold nothing is reserved: a rise that small leaves the header
// collapsed, and it could not have reached under the bar anyway.
function offsetOf(element) {
  var styles = getComputedStyle(document.documentElement);
  var buffer = parseFloat(styles.getPropertyValue('--te-pdp-sticky-top')) || 0;
  var resting = element.getBoundingClientRect().top + window.scrollY - buffer;
  var rise = window.scrollY - resting;
  var target = resting;
  if (rise > RISE_THRESHOLD) {
    target = resting - headerReserve();
  }
  return target;
}
function slideFor(root, variantId) {
  var holders = _toConsumableArray(root.querySelectorAll(SLIDE_VARIANTS));
  var holder = holders.find(function (node) {
    var ids = (node.getAttribute('data-variant-id') || '').split(',').map(function (id) {
      return id.trim();
    });
    return ids.indexOf(String(variantId)) >= 0;
  });
  return holder ? holder.closest(SLIDE) || holder : null;
}
function update(form) {
  var root = document.querySelector('.product') || document;
  var variants = (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.variantsFrom)(root, JSON_SCRIPT);
  var names = (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.optionNamesFrom)(root, JSON_SCRIPT);
  var variant = (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.matchVariant)(variants, (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.chosenOptions)(form), names);
  var slide = variant ? slideFor(root, variant.id) : null;
  if (slide) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(offsetOf(slide), 0),
      behavior: reduced ? 'auto' : 'smooth'
    });
  }
}
function onInteraction(event) {
  var form = event.target.closest ? event.target.closest(FORM) : null;
  if ((0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.isOptionGesture)(event, form)) {
    update(form);
  }
}
function initPdpMedia() {
  document.addEventListener('change', onInteraction);
  document.addEventListener('click', onInteraction);
}

/***/ }),

/***/ "./src/js/pdp-stock.js":
/*!*****************************!*\
  !*** ./src/js/pdp-stock.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initPdpStock)
/* harmony export */ });
/* harmony import */ var _variant_options__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./variant-options */ "./src/js/variant-options.js");
/**
 * "Add to my project" goes away when the chosen combination is not in stock.
 *
 * The option pills themselves stay live — every attribute is selectable, a
 * sold-out one is struck through by src/scss/_options.scss, and clicking it still
 * brings its photograph up through src/js/pdp-media.js. What a shopper cannot do
 * is add it, so the button is what disappears. Adam, 2026-09-02.
 *
 * WHY THIS CANNOT COME FROM THE THEME. snippets/product-options.liquid renders a
 * hidden `select[name="id"]` holding only the variants that are AVAILABLE, and
 * that select is what the theme's own form logic reads. A sold-out combination is
 * not in it, so the theme never learns one has been chosen and never disables its
 * button. The pills are the only control that knows.
 *
 * So this works the pills out itself, the way the gallery already does — same
 * module, same matcher, same gesture test. See src/js/variant-options.js.
 *
 * PDP ONLY. The quick view's form is `.quick-view-form` and carries no product
 * JSON of its own, so it is untouched here; the theme disables its button through
 * the machinery above, which is enough for a modal that shows one option row.
 */

var FORM = '.product-form';
var JSON_SCRIPT = '[data-js-product-json]';
var UNAVAILABLE = 'is-variant-unavailable';

// The payload sits INSIDE the form — snippets/product-form.liquid includes
// product-json.liquid as the form's first child — so the form is the root, and a
// second product form on the page could not read the wrong one.
function isUnavailable(form) {
  var variants = (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.variantsFrom)(form, JSON_SCRIPT);
  var chosen = (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.chosenOptions)(form);
  var variant = (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.matchVariant)(variants, chosen, (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.optionNamesFrom)(form, JSON_SCRIPT));
  var unavailable = false;

  // Nothing parsed, or nothing chosen, is not the same as sold out. A button that
  // vanishes because the JSON was malformed is worse than one that stays and lets
  // the cart refuse the line, so silence leaves the button alone.
  if (variants.length > 0 && Object.keys(chosen).length > 0) {
    unavailable = !variant || variant.available === false;
  }
  return unavailable;
}
function update(form) {
  form.classList.toggle(UNAVAILABLE, isUnavailable(form));
}
function onInteraction(event) {
  var form = event.target.closest ? event.target.closest(FORM) : null;
  if ((0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.isOptionGesture)(event, form)) {
    update(form);
  }
}
function initPdpStock() {
  // The pill Liquid checks is the first AVAILABLE variant, so the opening state is
  // almost always in stock — almost, because a product with no stock at all has no
  // available variant to check and lands here already unavailable.
  document.querySelectorAll(FORM).forEach(function (form) {
    return update(form);
  });
  document.addEventListener('change', onInteraction);
  document.addEventListener('click', onInteraction);
}

/***/ }),

/***/ "./src/js/project-count.js":
/*!*********************************!*\
  !*** ./src/js/project-count.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initProjectCount)
/* harmony export */ });
/**
 * My Project (n) — how many different tiles are on the list.
 *
 * The header's project link is rendered by snippets/te-header-project.liquid with
 * its count empty, because the count is not Liquid's to know: the Samita Request
 * a Quote app keeps the list on the client and rebuilds it as tiles are added and
 * removed.
 *
 * THE NUMBER IS THE ENTRY COUNT, NOT THE QUANTITY. Adam's call, 2026-08-24, and
 * it is how a cart reads: three hundred of one tile is one line, not three
 * hundred. The app's own "Quote (n)" tab counts tiles — with a single line at a
 * quantity of 1400 it read 1400 — so the tab is not the source.
 *
 * THE SOURCE IS localStorage, and the shape of it is the point: the app writes ONE
 * KEY PER ITEM,
 *
 *   <shop>/samitaRFQ/group_0.item_1
 *   <shop>/samitaRFQ/group_0.item_2
 *
 * alongside a `group_0` record and a `grfq/defaultGroupKey`. So the entry count is
 * the number of keys ending `.item_<n>`, which needs no parsing of the values and
 * no call into `GRFQApp` — whose eighty-odd undocumented methods include
 * `getQuoteItems` and `quoteCounter`, either of which could change shape without
 * warning. Keys are data; data is the stabler contract.
 *
 * Counting keys rather than reading the highest index is deliberate: the app's
 * `cloneItem` / `getNextDuplicateKey` mean indices need not be contiguous, and a
 * removal leaves a gap. It also sums correctly across groups if the store ever
 * uses more than one, and it cannot count the group record itself, because that key
 * does not end in `.item_<n>`.
 *
 * The shop prefix is matched loosely, on the suffix only, so nothing breaks when
 * the store moves to its own domain.
 *
 * THREE SIGNALS, because `localStorage` fires no event in the tab that wrote it:
 *
 *   `grfq.quote.added`  the app's own custom event on `document`, dispatched at the
 *                       end of its `addToQuote` with the entry in `detail.data`.
 *                       The best of the three — it is the app telling us, rather
 *                       than us noticing.
 *   a DOM mutation      the app re-renders its tab (hidden by _header.scss, and
 *                       kept in the DOM for exactly this reason) on every add and
 *                       every REMOVAL. Removals are why the observer stays: there
 *                       is no `grfq.quote.removed`.
 *   `storage`           a change made in a second tab, which neither of the others
 *                       can see.
 *
 * All three land on the same idempotent `apply`, so overlapping signals cost a
 * string comparison.
 *
 * Writing the count is itself a mutation, so the observer sees its own work. That
 * settles rather than loops because the write is skipped once the rendered text
 * already matches.
 */
var LINK = '.js-te-project';
var COUNT = '[data-te-project-count]';

// One key per item. Anchored at the end so the `group_0` record and
// `grfq/defaultGroupKey` cannot be mistaken for entries.
var ITEM_KEY = /\/samitaRFQ\/group_\d+\.item_\d+$/;

// THE ONE SEAM. Everything below takes a number from here and does not care where
// it came from.
function countTiles() {
  var count = 0;

  // Storage throws rather than returning null when it is unavailable — Safari's
  // private mode, or a browser with site data switched off. No list is readable
  // there, which is the same position as an empty one.
  try {
    count = Object.keys(window.localStorage).filter(function (key) {
      return ITEM_KEY.test(key);
    }).length;
  } catch (error) {
    count = 0;
  }
  return count;
}

// The NUMBER only. Its brackets are drawn in _header.scss, because below the
// header's breakpoint the same element is a pill on the icon and a pill is not a
// parenthetical — punctuation belongs to the presentation, not to the count.
function labelFor(count) {
  var label = '';
  if (count > 0) {
    label = String(count);
  }
  return label;
}
function apply() {
  var target = document.querySelector("".concat(LINK, " ").concat(COUNT));
  var wanted = labelFor(countTiles());
  if (target && target.textContent !== wanted) {
    target.textContent = wanted;
  }
}
function initProjectCount() {
  if (document.querySelector(LINK)) {
    var observer = new MutationObserver(apply);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    document.addEventListener('grfq.quote.added', apply);
    window.addEventListener('storage', apply);
    apply();
  }
}

/***/ }),

/***/ "./src/js/project-gallery.js":
/*!***********************************!*\
  !*** ./src/js/project-gallery.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initProjectGallery)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * The project gallery's lightbox.
 *
 * The PDP opens the base theme's zoom modal, which is a Swiper bound to
 * `product.media` — there is no product on a page, so it cannot be rendered
 * here. What is portable is the design, and this is the same one: a full-viewport
 * surface in the page's own background, the photograph contained inside it, and
 * the theme's circular close.
 *
 * IT DOES CARRY ARROWS, where the PDP's does not (Adam, 2026-08-31). _pdp.scss
 * hides the theme's chevrons deliberately — a product's lightbox is one
 * photograph of one thing. A project's is seven photographs of one house, and
 * cycling them is the reason for opening the first, so the way through cannot be
 * only the arrow keys.
 *
 * It replaces the seventy lines of `<script>` that sections/gallery-grid-modal
 * .liquid carried inline. Same job; here it is built with the rest of the
 * reskin's behaviour and can be read next to the CSS that dresses it.
 *
 * The gallery is the SECTION, not the page, so two galleries on one page each get
 * their own dialog and their own index — nothing here reaches across sections.
 */

var GALLERY = '[data-te-gallery]';
var DIALOG = '[data-te-lightbox]';
var IMAGE = '[data-te-lightbox-image]';
var OPEN = '[data-te-lightbox-open]';
var CLOSE = '[data-te-lightbox-close]';
var PREV = '[data-te-lightbox-prev]';
var NEXT = '[data-te-lightbox-next]';
var FULL = 'data-te-lightbox-full';
var ALT = 'data-te-lightbox-alt';
var OPEN_CLASS = 'is-open';

// `body.style.overflow` is the theme's own lock — main.build.js does exactly this
// for its modals and drawers — so the lightbox behaves like every other overlay
// on the site rather than inventing a second mechanism.
//
// The scrollbar going away is what makes the page jump sideways when the dialog
// opens. Its width is measured rather than assumed: it is 0 on a phone and on any
// desktop set to overlay scrollbars.
function lockScroll() {
  var gap = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = "".concat(gap, "px");
}
function unlockScroll() {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
}

// Each gallery is its own object: the buttons it owns, the dialog it owns, and
// the index of the photograph currently showing. Nothing is stored on the DOM
// beyond the `is-open` class the stylesheet reads.
function galleryIn(root) {
  var dialog = root.querySelector(DIALOG);
  var image = root.querySelector(IMAGE);
  var buttons = _toConsumableArray(root.querySelectorAll(OPEN));
  var close = root.querySelector(CLOSE);
  var arrows = [[root.querySelector(PREV), -1], [root.querySelector(NEXT), 1]];
  var cache = new Map();
  var index = 0;
  var opener = null;

  // Preloading a neighbour costs nothing visible and means the arrow keys do not
  // flash white between photographs.
  function preload(at) {
    var button = buttons[at];
    var wanted = button && cache.has(at) === false;
    if (wanted) {
      var preloaded = new Image();
      preloaded.src = button.getAttribute(FULL);
      cache.set(at, preloaded);
    }
  }
  function show(at) {
    var button = buttons[at];
    index = at;
    image.src = button.getAttribute(FULL);
    image.alt = button.getAttribute(ALT) || '';
    preload((at + 1) % buttons.length);
    preload((at - 1 + buttons.length) % buttons.length);
  }
  function open(at) {
    opener = buttons[at];
    show(at);
    dialog.classList.add(OPEN_CLASS);
    lockScroll();
    // A frame later, because `visibility` is what the class changes and an
    // element cannot take focus while it is still hidden.
    requestAnimationFrame(function () {
      return close.focus();
    });
  }
  function dismiss() {
    dialog.classList.remove(OPEN_CLASS);
    unlockScroll();

    // Back to the photograph that opened it, not to the top of the document.
    if (opener) {
      opener.focus();
      opener = null;
    }
  }
  function step(by) {
    show((index + by + buttons.length) % buttons.length);
  }
  function onKey(event) {
    var isOpen = dialog.classList.contains(OPEN_CLASS);
    var keys = {
      Escape: dismiss,
      ArrowLeft: function ArrowLeft() {
        return step(-1);
      },
      ArrowRight: function ArrowRight() {
        return step(1);
      }
    };
    if (isOpen && keys[event.key]) {
      event.preventDefault();
      keys[event.key]();
    }
  }
  function init() {
    buttons.forEach(function (button, at) {
      return button.addEventListener('click', function () {
        return open(at);
      });
    });
    close.addEventListener('click', dismiss);
    // The section only renders these when there is more than one photograph, so
    // a gallery of one simply has none to bind.
    arrows.filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        arrow = _ref2[0];
      return arrow;
    }).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        arrow = _ref4[0],
        by = _ref4[1];
      return arrow.addEventListener('click', function () {
        return step(by);
      });
    });
    // The surface around the photograph closes it; the photograph itself does
    // not, so a drag to save it is not a dismissal.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dismiss();
      }
    });
    document.addEventListener('keydown', onKey);
  }
  return Object.freeze({
    init: init
  });
}
function initProjectGallery() {
  var roots = _toConsumableArray(document.querySelectorAll(GALLERY));
  roots.filter(function (root) {
    return root.querySelector(DIALOG) && root.querySelectorAll(OPEN).length > 0;
  }).forEach(function (root) {
    return galleryIn(root).init();
  });
}

/***/ }),

/***/ "./src/js/quick-view-media.js":
/*!************************************!*\
  !*** ./src/js/quick-view-media.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initQuickViewMedia)
/* harmony export */ });
/* harmony import */ var _variant_options__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./variant-options */ "./src/js/variant-options.js");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


/**
 * Choosing a colour brings its photograph to the top of the column.
 *
 * Ghosting the rest was tried and dropped (Adam, 2026-08-20): the other images
 * are still worth looking at, so nothing is dimmed — the chosen one is simply
 * scrolled to. Which image belongs to which colour is now said out loud by the
 * caption pill on each one, so the dimming was carrying information that is on
 * the page anyway.
 *
 * The selected variant is worked out HERE rather than read off the theme's hidden
 * select, because the theme updates that select in its own change handler and
 * there is no ordering guarantee between the two. Everything needed is already in
 * the modal: the variants as JSON, and the image id on each slide.
 *
 * Only ever runs on a deliberate change. On open nothing is ghosted — dimming
 * most of the column the moment the modal appears would read as a loading state.
 */
var MEDIA = '.js-quick-view-media';
var SLIDER = '.js-quick-view-slider';
var ANCHOR = '.quick-view__heading';
var QUICK_VIEW = '.js-quick-view';
var FORM = '.js-quick-view-form';
var VARIANTS = '.js-quick-view-variants';
var SLIDE = '[data-te-media-id], [data-te-image-id]';

// Has the shopper picked anything in the modal that is currently open? Until they
// have, the gallery stays on the first photograph — see holdAtFirstSlide.
var picked = false;

// A variant carries both a featured_media and a featured_image, and only one of
// them is certain to share an id space with what the slide advertises. Media
// first because that is the pairing Shopify models directly.
var PAIRS = [['featured_media', 'data-te-media-id'], ['featured_image', 'data-te-image-id']];

// The image comes to rest LEVEL WITH THE TITLE (Adam, 2026-08-20). Measured
// against the title ITSELF rather than by subtracting a token from the container's
// top: that way the alignment is right even if the column's own inset is not what
// this module thinks it is, and there is one less number to keep in step. The
// heading is the thing the eye lines the image up with, so it is the thing to
// measure.
//
// Only ever scrolls the column — never the page — so `scrollTo` on the container
// rather than `scrollIntoView` on the slide.
// Below 992 the column is a Swiper carousel, and scrolling a carousel does
// nothing — it moves on a transform, not on scrollTop, which is why the flick to
// the chosen colour only worked sometimes on a phone. Swiper hangs its instance
// off its own element (`el.swiper`) and clears it on `destroy()`, so the presence
// of that instance IS the answer to "which layout am I in" — no media query to
// keep in step with the theme's.
function slideToSlide(swiper, container, slide) {
  var slides = _toConsumableArray(container.querySelectorAll('.swiper-slide'));
  var index = slides.indexOf(slide);
  if (index >= 0) {
    swiper.slideTo(index);
  }
}
function scrollToSlide(container, slide, anchor) {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var target = anchor ? anchor.getBoundingClientRect().top : container.getBoundingClientRect().top;
  var offset = container.scrollTop + slide.getBoundingClientRect().top - target;
  container.scrollTo({
    top: Math.max(offset, 0),
    behavior: reduced ? 'auto' : 'smooth'
  });
}
function slideFor(container, variant) {
  var slide = null;
  PAIRS.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      field = _ref2[0],
      attribute = _ref2[1];
    var id = variant && variant[field] ? variant[field].id : null;
    if (slide === null && id) {
      slide = container.querySelector("[".concat(attribute, "=\"").concat(id, "\"]"));
    }
  });
  return slide;
}
function update(form) {
  var root = form.closest('.js-quick-view') || document;
  var container = root.querySelector(MEDIA);
  if (container) {
    var variant = (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.matchVariant)((0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.variantsFrom)(root, VARIANTS), (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.chosenOptions)(form), (0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.optionNamesFrom)(root, VARIANTS));
    // A colour with no picture of its own leaves the column where it is rather
    // than scrolling somewhere arbitrary.
    var current = slideFor(container, variant);
    if (current) {
      var slider = current.closest(SLIDER);
      var swiper = slider ? slider.swiper : null;
      if (swiper) {
        slideToSlide(swiper, container, current);
      } else {
        scrollToSlide(container, current, root.querySelector(ANCHOR));
      }
    }
  }
}

// On a phone the gallery must OPEN on the first photograph, not on the selected
// variant's (Adam, 2026-08-20). The theme slides to the variant as it builds the
// modal, which is reasonable behaviour and not what is wanted here.
//
// Asserting slide 0 once is not enough on its own: the theme moves it during init
// and can move it again from its own change handler, and the order of that
// against us is not ours to rely on. So this HOLDS rather than sets — it listens
// for Swiper's own `slideChange` and puts the carousel back until the first real
// pick releases it. One event of the theme's own making, answered with one of
// Swiper's.
//
// Desktop needs none of this: a scrolling column already starts at its top, which
// is the first photograph.
function holdAtFirstSlide(root) {
  var slider = root.querySelector(SLIDER);
  var swiper = slider ? slider.swiper : null;
  if (swiper) {
    var hold = function hold() {
      if (!picked && swiper.activeIndex !== 0) {
        swiper.slideTo(0, 0);
      }
    };
    swiper.on('slideChange', hold);
    hold();
  }
}

// The modal is fetched and inserted whole, so opening it is a DOM insertion. Each
// one is a fresh gallery, so the pick flag resets with it.
function onOpen(records) {
  records.forEach(function (record) {
    record.addedNodes.forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.matches(QUICK_VIEW)) {
        picked = false;
        holdAtFirstSlide(node);
      }
    });
  });
}

// Two events, and a gesture test.
//
// `isTrusted` is the whole of the "don't move on open" fix: the theme dispatches
// its own change against the form while it is building the modal, and acting on
// that jumped a phone's carousel to the first variant's image before the shopper
// had touched anything. A synthetic event reports `isTrusted: false`; a finger or
// a mouse reports true. No timers, no flags, no guessing at the theme's order.
//
// `click` as well as `change` because re-picking the option that is ALREADY
// selected fires no change at all — and Adam is right that it should still bring
// that colour's photograph back (2026-08-20). Both firing for one pick is
// harmless: the second call resolves to the same slide and asks for the same
// position.
function onInteraction(event) {
  var form = event.target.closest ? event.target.closest(FORM) : null;
  if ((0,_variant_options__WEBPACK_IMPORTED_MODULE_0__.isOptionGesture)(event, form)) {
    picked = true;
    update(form);
  }
}
function initQuickViewMedia() {
  var observer = new MutationObserver(onOpen);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  document.addEventListener('change', onInteraction);
  document.addEventListener('click', onInteraction);
}

/***/ }),

/***/ "./src/js/quick-view-reopen.js":
/*!*************************************!*\
  !*** ./src/js/quick-view-reopen.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initQuickViewReopen)
/* harmony export */ });
/**
 * Make the SECOND quick view open on the first click.
 *
 * The theme's handler begins:
 *
 *     if (!f || n) return;
 *     const B = document.querySelector('.js-quick-view');
 *     if (B) { B.remove(); return; }        // <- here
 *     n = true; ... open ...
 *
 * and the modal is appended to <body> and merely hidden when it closes, never
 * removed. So from the second tile onwards the first click is spent deleting the
 * previous modal and returns without opening anything — click again and it works.
 * That reads exactly like "some quick views don't fire at all".
 *
 * This clears the stale node in the CAPTURE phase, before the theme's own
 * document-level listener runs, so its check finds nothing and goes straight to
 * opening. Only ever removes a modal that is already CLOSED — an open one is
 * behind its overlay and cannot be clicked past anyway, and removing it would
 * take the shopper's place with it.
 *
 * NOT fixed here, because it is beyond reach: that same handler latches `n = true`
 * before fetching and only clears it on the last line of a SUCCESSFUL open. Any
 * failure in between — a fetch that 404s, or its init bailing on a missing
 * element — leaves the flag set and every later quick view on the page is
 * swallowed until a reload. Worth knowing when one genuinely never opens: it is
 * usually the previous product that broke it, not that one.
 */
var BUTTON = '.js-product-card-quick-view-button';
var MODAL = '.js-quick-view';
var ACTIVE = 'is-active';
function clearStale(event) {
  var target = event.target;
  if (target.closest && target.closest(BUTTON)) {
    var modal = document.querySelector(MODAL);
    if (modal && !modal.classList.contains(ACTIVE)) {
      modal.remove();
    }
  }
}
function initQuickViewReopen() {
  document.addEventListener('click', clearStale, true);
}

/***/ }),

/***/ "./src/js/quote-add.js":
/*!*****************************!*\
  !*** ./src/js/quote-add.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initQuoteAdd)
/* harmony export */ });
/**
 * "Add to my project" — hand the add to the app, not to the cart.
 *
 * My Project is the sa-request-a-quote app's list. /pages/request-for-quote is
 * the app rendering it, and the header count reads the app's own localStorage
 * keys (src/js/project-count.js). But every "Add to my project" button in this
 * theme is a real Shopify product form's submit wearing our label, so left alone
 * it posts to /cart/add and the tile lands somewhere the customer never sees:
 * nothing on the project page, nothing in the header.
 *
 * THE APP'S ADD IS `GRFQApp.addProduct(button, productId)`. Read off the app's own
 * bundle, that lazy-loads a chunk and calls `addToQuote(button, productId)`, which
 * builds the entry with `quoteData(button, productId)` and then does all of the
 * work itself — writes its localStorage key, updates its cart, re-renders its
 * widget, and dispatches `grfq.quote.added` on `document`. Which is exactly why it
 * is worth calling rather than reproducing: the app's private key format
 * (`…/groupId=0/pId=…/vId=…/option="…"`) and its in-memory cache both stay its own
 * business, and there is one source of truth instead of two that can disagree.
 *
 * WHAT `quoteData` NEEDS, and where each part comes from:
 *
 *   the form      `window.forceProductFormSelector` if it is set, and otherwise
 *                 `button.closest('form')` — but only for a button carrying the
 *                 app's own `rfq-btn` class. See below: we use the first.
 *   the variant   `select[name="id"]` in that form, one of the app's own
 *                 `variantSelector` patterns — our hidden picker.
 *   the quantity  `[name="quantity"]`, which product-quantity.liquid renders.
 *   the product   looked up by id in `GRFQConfigs.products`, the catalogue the app
 *                 collects from the page. 16 entries on a collection page, so a
 *                 quick view opened from a grid resolves.
 *
 * WHY `forceProductFormSelector` AND NOT `rfq-btn`. The class route works, and it
 * was the first thing tried: put `rfq-btn` on a hidden proxy inside the form and
 * `closest('form')` finds the right one. It also breaks the product page. The app
 * runs at load, sees an `rfq-btn` inside the product form, concludes it has placed
 * its own quote button there, and HIDES the theme's add to cart — which is what
 * `GRFQConfigs.classes.rfqHideAtcBtn` and `handleHideButtonFunction` are for. The
 * quick view got away with it only because it is injected after the app has run.
 *
 * `forceProductFormSelector` is the app's own escape hatch for themes it cannot
 * pattern-match, and taking it means our proxy needs no app class at all — so
 * there is nothing on the page for the app to recognise, and nothing of the
 * theme's for it to hide. The selector is set and cleared around each add rather
 * than left standing, because it is a single global that would otherwise point
 * every later add at whichever form was used last.
 *
 * The element handed over is still a hidden proxy rather than the visible button:
 * the app sets `disabled` on it for the duration of the add, and our button is the
 * comp's wine pill with `quote-unlock.js` watching it.
 *
 * SELF-SCOPING, deliberately. This acts only where it finds both a proxy and a
 * product id in the form, and otherwise lets the submit through untouched. So
 * giving the PDP's button the same treatment is two attributes in
 * product-add-to-cart.liquid and no change here — and any other submit in the
 * theme is unaffected by construction rather than by a selector that has to be
 * kept in step.
 *
 * `capture` on `document` is load-bearing: the theme binds its own handler to this
 * button and would post the form. Running first and stopping the event is what
 * takes the cart out of the path.
 *
 * AND IT MUST NOT NAVIGATE. The app ends a successful add by reading
 * `GRFQConfigs.message_type_afteratq` and doing one of four things: its own popup,
 * its quote-form popup, a toast, or — the default here, and the fallback for any
 * value it does not recognise — sending the customer to /pages/request-for-quote.
 * A redirect is defensible from a product page. From a quick view it is not: you
 * came to add one tile and you have lost the grid you were browsing, which for a
 * shop where people pick four or five is the difference between a list and a chore.
 *
 * That looked like it needed the app's SETTING changed, which would have been
 * live-shared and so a decision rather than a fix. It does not: `GRFQConfigs` is a
 * plain global and the branch above reads it when the add runs, not when the page
 * loads. So the preference is overridden in memory, here, for the pages this
 * script runs on — the stored setting is untouched, and LIVE IS UNAFFECTED.
 *
 * `toast` of the three alternatives, because it is the only one that leaves the
 * customer where they were. It is the app's own toast and so arrives unstyled by the reskin;
 * dressing it, or replacing it with our own confirmation, is a separate job.
 */
var AFTER_ADD = 'toast';

// "Product added to quote" is the app's own string, and quote is not the word this
// site uses for the list — the header, the page and every button say My Project.
// Adam 2026-08-24. Overridden in memory for the same reason as the mode above: the
// stored translation is one set for every theme, and live still needs its own.
var TOAST_MESSAGE = 'Added to My Project';
var TARGET = '[data-te-quote-target]';
var PROXY = '[data-te-quote-proxy]';
var PRODUCT = 'data-te-quote-product';
var FORM_FLAG = 'data-te-quote-form';
var FORM_SELECTOR = '[data-te-quote-form]';
function appReady() {
  return Boolean(window.GRFQApp && typeof window.GRFQApp.addProduct === 'function');
}

// The app publishes its config as a plain global and reads both of these at the END
// of an add — the mode to choose how it reports, the translation to fill it — so
// they are ours to state without touching what the store has stored. Set at the
// moment of adding rather than at init: the app's script is an embed and need not
// have run by DOMContentLoaded, whereas by here it certainly has.
function speakForOurselves() {
  if (window.GRFQConfigs) {
    window.GRFQConfigs.message_type_afteratq = AFTER_ADD;
    if (window.GRFQConfigs.translations) {
      window.GRFQConfigs.translations.toast_message = TOAST_MESSAGE;
    }
  }
}

// Both halves have to be present, and in the same form, or this is not a button
// the app can add for and the submit is left alone.
function handoverFor(button) {
  var form = button.closest('form');
  var productId = button.getAttribute(PRODUCT);
  var handover = null;
  if (form && productId) {
    var proxy = form.querySelector(PROXY);
    if (proxy) {
      handover = {
        form: form,
        proxy: proxy,
        productId: productId
      };
    }
  }
  return handover;
}

// Point the app at THIS form for the duration of one add, then stop pointing. The
// flag goes on the form rather than the selector naming it, so the selector is a
// constant and there is nothing to build or escape.
function add(handover) {
  speakForOurselves();
  handover.form.setAttribute(FORM_FLAG, '');
  window.forceProductFormSelector = FORM_SELECTOR;
  var done = function done() {
    handover.form.removeAttribute(FORM_FLAG);
    delete window.forceProductFormSelector;
  };

  // `addProduct` is async — it fetches its own chunk before adding. Failures are
  // the app's to report; swallowing them here would hide a broken add behind a
  // button that looked like it worked. `finally` only cleans up after it, and the
  // app reads the selector before its own first `await`, so the window is safe.
  return window.GRFQApp.addProduct(handover.proxy, handover.productId)["finally"](done);
}
function intercept(event) {
  var button = event.target.closest ? event.target.closest(TARGET) : null;
  var handover = button ? handoverFor(button) : null;
  if (handover && appReady()) {
    event.preventDefault();
    event.stopImmediatePropagation();
    add(handover);
  }
}
function initQuoteAdd() {
  document.addEventListener('click', intercept, true);
}

/***/ }),

/***/ "./src/js/quote-page.js":
/*!******************************!*\
  !*** ./src/js/quote-page.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initQuotePage)
/* harmony export */ });
/**
 * My Project — the four strings the app does not render.
 *
 * The page at /pages/request-for-quote is built at runtime by the Samita Request
 * a Quote app, and the comp (screens/templates/my project.png) asks for copy the
 * app's own markup has no element for, or has under a different name:
 *
 *   "Your tiles"    the panel of tiles has no heading at all
 *   "Request a quote"  the form's <h3> reads "Form Request", the app's default
 *   "Add tiles"     the add button's label reads "Add products to group"
 *   "Qty"           the quantity column header reads "Quantity"
 *
 * Done here rather than in the app's settings because the app's settings are
 * SHARED WITH LIVE — the same labels, the same custom CSS, one set for every
 * theme. Nothing in this reskin is allowed to reach the live site before it is
 * signed off, so the labels are corrected in the theme, where a change is scoped
 * to whichever theme is being previewed. When the reskin does go live these four
 * belong in the app instead, at which point this module can go.
 *
 * WHY AN OBSERVER. None of this markup exists at DOMContentLoaded: the app fetches
 * the list and builds the form afterwards, and it rebuilds the table from scratch
 * on every quantity change and every removal. So the work is idempotent and runs
 * again whenever the subtree changes.
 *
 * Writing to the DOM is itself a mutation, so the observer sees its own work. That
 * settles rather than loops, because every step below is a no-op once it has been
 * applied and the comparison is on rendered text, not on markup.
 */
var PAGE = 'page-request-for-quote';
var CARD = '.cartPage__main';
var CARD_TITLE = 'te-quote-card-title';
var FORM_TITLE = '.grfq-form-wrapper > h3';
var ADD_LABEL = '.grfq-add-product-section p';
var QTY_HEADER = '.quote-table thead th:last-child';
var COPY = {
  card: 'Your tiles',
  form: 'Request a quote',
  add: 'Add tiles',
  qty: 'Qty'
};
function retitle(element, wanted) {
  if (element && element.textContent.trim() !== wanted) {
    element.textContent = wanted;
  }
}
function heading() {
  var element = document.createElement('h2');
  element.className = CARD_TITLE;
  element.textContent = COPY.card;
  return element;
}

// The panel's heading is ours to add, so it goes in as the card's first child
// rather than replacing anything. `:scope >` keeps it to this card's own children:
// the app nests a second, hidden card for its quick-add search.
function addCardTitle() {
  var card = document.querySelector(CARD);
  var existing = card ? card.querySelector(":scope > .".concat(CARD_TITLE)) : null;
  if (card && !existing) {
    card.prepend(heading());
  }
}
function apply() {
  addCardTitle();
  retitle(document.querySelector(FORM_TITLE), COPY.form);
  retitle(document.querySelector(ADD_LABEL), COPY.add);
  retitle(document.querySelector(QTY_HEADER), COPY.qty);
}
function initQuotePage() {
  if (document.body.classList.contains(PAGE)) {
    var observer = new MutationObserver(apply);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    apply();
  }
}

/***/ }),

/***/ "./src/js/quote-unlock.js":
/*!********************************!*\
  !*** ./src/js/quote-unlock.js ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initQuoteUnlock)
/* harmony export */ });
/**
 * Add to my project — never RELABELLED. Blocking is now the theme's business.
 *
 * The base build does two things to this button, and only one of them is still
 * undone here:
 *
 *   1. it sets `disabled` on the submit whenever the selected variant is
 *      unavailable (`o.disabled = !r.available`), on every option change — LEFT
 *      ALONE as of 2026-09-02, and src/scss/_quick-view.scss hides the button on
 *      that attribute. Note it does this ONLY on change: `updateButtons()` has one
 *      caller, `formChangeHandler`. The opening state comes from Liquid instead,
 *      in snippets/quick-view-form.liquid;
 *   2. it rewrites the button's contents from the translations object —
 *      "Add to cart", "Sold out", "Unavailable" — which loses our label AND the
 *      stacked-tiles icon with it. Still undone here.
 *
 * WHY (1) CHANGED. Until 2026-09-02 this cleared the attribute, on the reasoning
 * that Tile Empire's project list is a quote REQUEST rather than a checkout, so
 * asking about a tile that is not on the floor today is exactly the case that
 * matters. That reasoning was sound; the evidence under it was not. It was
 * written while `theme dev` geolocated to Vietnam and EVERY variant in the
 * catalogue read unavailable — see src/scss/_variables.scss — so unlocking the
 * button cost nothing visible. On real stock data it costs a shopper adding a
 * tile they cannot have, and Adam has chosen to gate on stock: "make sure same
 * rules apply inside the quick view", matching the PDP's src/js/pdp-stock.js.
 *
 * (2) is not about stock and never was: the script rewrites the label on every
 * option change whether the variant is available or not. So this module stays for
 * as long as the base build does.
 *
 * The wanted contents come from a <template> beside the button rather than from a
 * snapshot, because the theme writes the label synchronously as it inserts the
 * modal, before an observer could have seen the original.
 *
 * Writing to the button is itself a mutation, so the observer sees its own work.
 * That settles rather than loops: each fix is a no-op once applied, and the
 * comparison is on rendered text, not on markup.
 */
var BUTTON = '[data-te-quote-target]';
var LABEL = '[data-te-quote-label]';
function labelFor(button) {
  var form = button.closest('form') || document;
  return form.querySelector(LABEL);
}
function restore(button) {
  var template = labelFor(button);
  var wanted = template ? template.content.textContent.trim() : '';
  var current = button.textContent.trim();
  if (wanted !== '' && current !== wanted) {
    button.replaceChildren(template.content.cloneNode(true));
  }
}
function restoreWithin(node) {
  if (node.nodeType === Node.ELEMENT_NODE) {
    if (node.matches(BUTTON)) {
      restore(node);
    }
    node.querySelectorAll(BUTTON).forEach(restore);
  }
}
function handle(records) {
  records.forEach(function (record) {
    var target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
    var button = target ? target.closest(BUTTON) : null;
    if (button) {
      restore(button);
    }
    record.addedNodes.forEach(restoreWithin);
  });
}
function initQuoteUnlock() {
  // The quick view is fetched and inserted whole, so there is nothing to bind to
  // at load — the observer watches for it arriving as well as for the label and
  // the attribute being rewritten once it has.
  var observer = new MutationObserver(handle);

  // No `attributes` any more: `disabled` was the only one watched, and it is now
  // the theme's to set. The label arrives as a childList or characterData change,
  // which is what is left.
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
  restoreWithin(document.body);
}

/***/ }),

/***/ "./src/js/rail.js":
/*!************************!*\
  !*** ./src/js/rail.js ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initRail)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Card rail — the scroll indicator under the rail, and drag-to-scroll for the
 * mouse.
 *
 * INDICATOR. Two fractions of the track are published rather than pixel values,
 * so the stylesheet keeps the geometry and this file only ever knows ratios:
 *
 *   --rail-thumb    how much of the content is on screen  (thumb width)
 *   --rail-offset   how far through the scroll we are     (thumb position)
 *
 * The offset is pre-multiplied by (1 - thumb) here so the CSS is a plain
 * multiplication with no division by a custom property. Both default to 1 and 0
 * in the stylesheet, so a blocked script leaves a full bar — "nothing to
 * scroll" — rather than an empty one.
 *
 * DRAG. Mouse only. Touch and trackpads already scroll this natively, with
 * momentum we cannot better, and taking their events would replace that with
 * something worse. A drag past DRAG_THRESHOLD swallows the click that follows
 * it, so releasing over a card does not open it.
 *
 * CAPTURE IS TAKEN LATE, and that is the whole reason a card is clickable. See
 * the note on onPointerMove.
 *
 * MOMENTUM. Because the drag writes scrollLeft directly, the browser has no
 * gesture to carry: the rail stopped dead the instant the button came up, while
 * the same flick on a touchscreen coasted. So the coast is written here — the
 * pointer's velocity is sampled through the drag and decays after the release.
 *
 * Deliberately NOT gated on prefers-reduced-motion, which the rest of the reskin
 * honours everywhere. Momentum is not decoration, it is the second half of a
 * gesture the reader made, and the browser does not withdraw it from native
 * touch scrolling under that preference either. Gating it here would leave the
 * mouse and the touchscreen behaving differently for exactly the readers least
 * helped by the difference.
 */
var SELECTOR = '.js-rail';

// Far enough that a click with a shaky hand still opens the card, short enough
// that a deliberate drag never does.
var DRAG_THRESHOLD = 5;

// The coast's time constant: velocity falls by 1/e every FLING_TAU. Distance
// travelled is release velocity x tau, so a moderate flick (~1.5px/ms) throws
// the rail about one card and a hard one about two — the right scale for a
// component whose whole job is to suggest there is more to the right.
var FLING_TAU = 300;

// Below this the coast is over: a twentieth of a pixel per millisecond is three
// pixels a second, which is not movement. It is also what bounds the duration —
// an exponential never reaches zero, so something has to call it.
var FLING_MIN_VELOCITY = 0.05;

// How much of each new sample to believe. Raw per-event deltas are noisy enough
// that the last one before release is a poor estimate on its own; this is a
// running average weighted towards recent movement.
var VELOCITY_SMOOTHING = 0.35;

// Hold still this long before letting go and the rail stays put. Without it a
// reader who drags, pauses to look, then releases gets thrown by whatever
// velocity was last sampled — the rail moving after they had parked it.
var VELOCITY_TIMEOUT = 80;
var Rail = /*#__PURE__*/function () {
  function Rail(scroller) {
    _classCallCheck(this, Rail);
    this.scroller = scroller;
    this.section = scroller.closest('.rail') || scroller.parentElement;
    this.indicator = this.section.querySelector('.rail__indicator');
    this.dragging = false;
    this.captured = false;
    this.travelled = 0;
    this.originX = 0;
    this.originScroll = 0;
    this.queued = false;

    // Momentum state. `velocity` is in scrollLeft pixels per millisecond, i.e.
    // the OPPOSITE sign to the pointer's own travel — the content moves against
    // the hand.
    this.velocity = 0;
    this.lastMoveX = 0;
    this.lastMoveTime = 0;
    this.flingFrame = 0;
    this.flingTime = 0;
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onWheel = this.onWheel.bind(this);
    this.onFlingFrame = this.onFlingFrame.bind(this);
  }
  return _createClass(Rail, [{
    key: "start",
    value: function start() {
      this.scroller.addEventListener('scroll', this.onScroll, {
        passive: true
      });
      window.addEventListener('resize', this.onScroll, {
        passive: true
      });
      this.scroller.addEventListener('pointerdown', this.onPointerDown);
      this.scroller.addEventListener('pointermove', this.onPointerMove);
      this.scroller.addEventListener('pointerup', this.onPointerUp);
      this.scroller.addEventListener('pointercancel', this.onPointerUp);
      // Capture phase, so a suppressed click never reaches the card's own link.
      this.scroller.addEventListener('click', this.onClick, true);

      // A trackpad or wheel scroll during a coast would be two forces on one
      // scroller. The reader's hand wins.
      this.scroller.addEventListener('wheel', this.onWheel, {
        passive: true
      });

      // The cards are lazy-loaded, so scrollWidth is not final at DOMContentLoaded
      // — it grows as images arrive and settle into their aspect box. Watching the
      // scroller keeps the thumb honest without polling.
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onScroll);
        this.observer.observe(this.scroller);
      }
      this.update();
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown(event) {
      // Before the pointer-type test, so a touch or a stylus landing on a coasting
      // rail stops it too — any new contact means the reader wants it where it is.
      this.stopFling();
      if (event.pointerType !== 'mouse' || event.button !== 0) {
        return;
      }
      this.dragging = true;
      this.captured = false;
      this.travelled = 0;
      this.originX = event.clientX;
      this.originScroll = this.scroller.scrollLeft;
      this.lastMoveX = event.clientX;
      this.lastMoveTime = event.timeStamp;
      this.scroller.classList.add('is-dragging');
    }
  }, {
    key: "onPointerMove",
    value: function onPointerMove(event) {
      if (!this.dragging) {
        return;
      }
      var moved = event.clientX - this.originX;
      this.travelled = Math.max(this.travelled, Math.abs(moved));

      // CAPTURE HERE, NOT ON POINTERDOWN. Capturing on the press made every card
      // in both homepage rails unclickable (Adam, 2026-09-04): while a pointer is
      // captured the browser retargets the compatibility mouse events to the
      // capturing element, so `mousedown` and `mouseup` both landed on the
      // scroller, `click` fired at the scroller rather than at the card's <a>, and
      // no link was ever followed. Releasing capture in `onPointerUp` does not
      // undo it — by then the click's target has already been decided.
      //
      // Past the threshold it is a drag rather than a click, and capture is worth
      // having: the pointer may leave the scroller mid-gesture and the drag still
      // has to track it. A click never gets here, so a click never captures.
      if (!this.captured && this.travelled > DRAG_THRESHOLD) {
        this.scroller.setPointerCapture(event.pointerId);
        this.captured = true;
      }
      this.scroller.scrollLeft = this.originScroll - moved;
      this.sample(event.clientX, event.timeStamp);
    }

    // Running average of the pointer's velocity, read as a scroll velocity.
  }, {
    key: "sample",
    value: function sample(x, time) {
      var elapsed = time - this.lastMoveTime;

      // Two events in the same millisecond carry no velocity between them, and
      // coalesced pointer events do arrive that way.
      if (elapsed > 0) {
        var instant = -(x - this.lastMoveX) / elapsed;
        this.velocity = this.velocity * (1 - VELOCITY_SMOOTHING) + instant * VELOCITY_SMOOTHING;
        this.lastMoveX = x;
        this.lastMoveTime = time;
      }
    }
  }, {
    key: "onPointerUp",
    value: function onPointerUp(event) {
      if (!this.dragging) {
        return;
      }
      this.dragging = false;
      if (this.captured && this.scroller.hasPointerCapture(event.pointerId)) {
        this.scroller.releasePointerCapture(event.pointerId);
      }
      this.captured = false;
      this.scroller.classList.remove('is-dragging');
      this.startFling(event.timeStamp);
    }
  }, {
    key: "startFling",
    value: function startFling(time) {
      var stalled = time - this.lastMoveTime > VELOCITY_TIMEOUT;
      var slow = Math.abs(this.velocity) < FLING_MIN_VELOCITY;
      if (stalled || slow) {
        this.velocity = 0;
      } else {
        this.flingTime = time;
        this.flingFrame = window.requestAnimationFrame(this.onFlingFrame);
      }
    }
  }, {
    key: "onFlingFrame",
    value: function onFlingFrame(time) {
      var elapsed = time - this.flingTime;
      var limit = this.scroller.scrollWidth - this.scroller.clientWidth;
      var target = this.scroller.scrollLeft + this.velocity * elapsed;
      var clamped = Math.min(Math.max(target, 0), limit);
      this.flingTime = time;
      this.scroller.scrollLeft = clamped;

      // Decay from ELAPSED TIME, not per frame. A per-frame factor would throw the
      // rail twice as far on a 120Hz screen as on a 60Hz one.
      this.velocity *= Math.exp(-elapsed / FLING_TAU);

      // Clamping means an end of the rail arrived and the coast has nowhere left
      // to go. Checked against the unclamped target rather than by comparing
      // scrollLeft before and after, which a sub-pixel frame cannot distinguish
      // from being blocked.
      var blocked = clamped !== target;
      var coasting = Math.abs(this.velocity) > FLING_MIN_VELOCITY;
      if (coasting && !blocked) {
        this.flingFrame = window.requestAnimationFrame(this.onFlingFrame);
      } else {
        this.stopFling();
      }
    }
  }, {
    key: "stopFling",
    value: function stopFling() {
      if (this.flingFrame) {
        window.cancelAnimationFrame(this.flingFrame);
        this.flingFrame = 0;
      }
      this.velocity = 0;
    }
  }, {
    key: "onWheel",
    value: function onWheel() {
      this.stopFling();
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      if (this.travelled <= DRAG_THRESHOLD) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      this.travelled = 0;
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      if (this.queued) {
        return;
      }
      this.queued = true;
      window.requestAnimationFrame(this.update);
    }
  }, {
    key: "update",
    value: function update() {
      this.queued = false;
      var _this$scroller = this.scroller,
        scrollLeft = _this$scroller.scrollLeft,
        scrollWidth = _this$scroller.scrollWidth,
        clientWidth = _this$scroller.clientWidth;
      var scrollable = scrollWidth - clientWidth;
      var thumb = 1;
      var offset = 0;

      // A sub-pixel remainder is not a scrollable rail — treat it as static, or
      // the bar flickers to full width on a fractional layout.
      if (scrollable > 1) {
        thumb = clientWidth / scrollWidth;
        offset = scrollLeft / scrollable * (1 - thumb);
      }
      this.section.style.setProperty('--rail-thumb', thumb);
      this.section.style.setProperty('--rail-offset', offset);
      this.scroller.classList.toggle('is-scrollable', scrollable > 1);
      if (this.indicator) {
        this.indicator.hidden = scrollable <= 1;
      }
    }
  }]);
}();
function initRail() {
  var scrollers = document.querySelectorAll(SELECTOR);
  var rails = [];
  scrollers.forEach(function (scroller) {
    var rail = new Rail(scroller);
    rail.start();
    rails.push(rail);
  });
  return rails;
}

/***/ }),

/***/ "./src/js/reveal.js":
/*!**************************!*\
  !*** ./src/js/reveal.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initReveal)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Reveal — adds `is-revealed` to a `[data-te-reveal]` element the first time it
 * reaches the trigger line, and never touches it again.
 *
 * That is the whole responsibility. What fades, how far it lifts, how long it
 * takes and in what order a group's children arrive are all in _reveal.scss —
 * per the entry point's convention that styling stays in the stylesheet.
 *
 * A single observer serves the page rather than one per element: the callback
 * is handed only the elements that crossed, so the cost is the same and there
 * is one object to reconnect when the theme editor swaps a section.
 */
var SELECTOR = '[data-te-reveal]';
var REVEALED = 'is-revealed';

// The class that arms the CSS. Set from here rather than in the markup so that
// a blocked or broken custom.js leaves the page visible instead of blank.
var ARMED = 'te-reveal';

// Trigger a tenth of the viewport up from the bottom edge. On the last screen
// of the page there is nothing left to scroll, so a group sitting in that strip
// has to be allowed to play on arrival — hence a fraction rather than a fixed
// inset, and a small one.
var ROOT_MARGIN = '0px 0px -10% 0px';
var Reveal = /*#__PURE__*/function () {
  function Reveal() {
    _classCallCheck(this, Reveal);
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: ROOT_MARGIN,
      threshold: 0
    });
  }

  // Takes any root — the document on load, a single section when the theme
  // editor re-renders one. Elements already revealed are skipped, so calling
  // this twice over the same tree is harmless.
  return _createClass(Reveal, [{
    key: "observe",
    value: function observe(root) {
      var _this = this;
      root.querySelectorAll(SELECTOR).forEach(function (element) {
        if (!element.classList.contains(REVEALED)) {
          _this.observer.observe(element);
        }
      });
    }
  }, {
    key: "onIntersect",
    value: function onIntersect(entries) {
      var _this2 = this;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(REVEALED);
          // One-way. Re-hiding on the way back up would replay the animation
          // every time the page is scrolled over, which reads as a page that
          // cannot settle.
          _this2.observer.unobserve(entry.target);
        }
      });
    }
  }]);
}();
function initReveal() {
  var stillness = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!stillness.matches) {
    document.documentElement.classList.add(ARMED);
    var reveal = new Reveal();
    reveal.observe(document);

    // The theme editor re-renders a section in place; its markup is new and
    // has never been observed.
    document.addEventListener('shopify:section:load', function (event) {
      reveal.observe(event.target);
    });
  }
}

/***/ }),

/***/ "./src/js/showrooms-recall.js":
/*!************************************!*\
  !*** ./src/js/showrooms-recall.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initShowroomsRecall)
/* harmony export */ });
/**
 * The showrooms page remembers the location you searched.
 *
 * Adam, 2026-09-02: "if we jump around the site and come back to stores, can it
 * remember our searched location?" Leave /pages/stores for a showroom's page or
 * anywhere else, come back, and the search you ran is still the one on screen.
 *
 * SESSION, NOT FOREVER. `sessionStorage`, so it lasts a visit and a tab and no
 * longer. A location typed last week resurfacing today would be a surprise rather
 * than a convenience, and "jump around the site and come back" is exactly the
 * span a session covers. Swap the constant below for `localStorage` if that turns
 * out to be the wrong call — nothing else changes.
 *
 * WHAT IT HAS TO OUTLAST. The app asks the browser for a location on page load
 * and searches from it (see the note on `#getbylocal` in src/scss/_showrooms.scss),
 * filling `#address` itself once the reverse geocode returns. So the remembered
 * search cannot simply be written in at DOMContentLoaded: the app would land on
 * top of it moments later. This waits for the app to stop moving first, then puts
 * the search back and runs it — the same fill-then-`submit.click()` route
 * sections/custom-showrooms.liquid already uses for "Use current location".
 *
 * WHAT IT DOES NOT DO IS TRUST ONE EVENT. Two cuts of this hung the save off the
 * Search button's click and nothing was ever stored (Adam, 2026-09-02: "it
 * returns null"). The button is the app's, inside the app's form, with the app's
 * handlers on it, and none of that is source we can read. So the click is now
 * only one of four nets, and the one that matters is `pagehide`: whatever the
 * panel reads as you LEAVE the page is what comes back, however the search that
 * put it there was run — button, Enter key, the app's own geolocation, or
 * something in it we have never seen.
 *
 * BUT IT CANNOT WAIT FOREVER, and the first cut did. It gated the restore on the
 * app having rendered an answer, which never happens if the permission prompt is
 * ignored rather than answered: the callback stays pending, the app stays waiting,
 * and nothing was ever put back (Adam, 2026-09-02 — "it doesn't remember my
 * search, it does pop up for browser detection but i ignore that both times").
 * So the wait is now capped. Answer quickly and we go after you; leave the prompt
 * sitting there and we go anyway.
 */
var STORE = 'sessionStorage';
var KEY = 'te:showrooms:search';
var POLL = 150;
// How long the app gets to draw its own answer before we stop deferring to it.
// Long enough for a geocode that is actually coming back, short enough that a
// prompt nobody answers does not hold the page in the wrong state.
var GRACE = 1800;
var FIELD = '#address';
var SUBMIT = '#submit-search';
var RESET = '#reset-search';
var KIND = 'select.chose-search-slt';
var RADIUS = '.search-radius-box input[type="range"]';
var RESULTS = '#main-slider-storelocator';
var EMPTY = '#results-empty';
var PAGE = '.te-showrooms';

// Every read and write goes through these two. Storage throws outright in some
// privacy modes, and a locator that cannot remember is the behaviour we started
// with — not a page that stops working.
function read() {
  var saved = null;
  try {
    saved = JSON.parse(window[STORE].getItem(KEY));
  } catch (error) {
    saved = null;
  }
  return saved;
}
function write(value) {
  try {
    if (value === null) {
      window[STORE].removeItem(KEY);
    } else {
      window[STORE].setItem(KEY, JSON.stringify(value));
    }
  } catch (error) {
    // Nothing to do about it and nothing worth saying.
  }
}

// Controls are looked up on the DOCUMENT, not inside the section. They are the
// app's, rendered by the app, and where it chooses to put them is its business —
// sections/custom-showrooms.liquid reaches for them the same way. `.te-showrooms`
// is only the test for "is this that page".
function control(selector) {
  return document.querySelector(selector);
}
function valueOf(selector) {
  var node = control(selector);
  return node ? node.value : null;
}

// The whole search, not just the words: the Location/Store name select and the
// radius decide what those words return, so restoring the text alone could hand
// back a different set of showrooms than the one being remembered.
function capture() {
  var place = valueOf(FIELD);
  var search = null;
  if (place) {
    search = {
      place: place,
      kind: valueOf(KIND),
      radius: valueOf(RADIUS)
    };
  }
  return search;
}

// `input` as well as `change`: the app draws the "Radius: 1000 kilometers" label
// off the range's own input event, and a value set from script fires neither.
function apply(selector, value) {
  var node = control(selector);
  if (node && value !== null && value !== undefined) {
    node.value = value;
    node.dispatchEvent(new Event('input', {
      bubbles: true
    }));
    node.dispatchEvent(new Event('change', {
      bubbles: true
    }));
  }
}
function restore(search) {
  apply(KIND, search.kind);
  apply(RADIUS, search.radius);

  // THE PLACE FIELD GETS A PLAIN ASSIGNMENT and no events, which is what the app
  // itself does when it reverse-geocodes into it — sections/custom-showrooms.liquid
  // says as much, and the search it then runs on `submit.click()` is the proof
  // that no event is needed. It is also a Places-style field, so an `input` on it
  // is an invitation to open a suggestions list over the panel.
  var field = control(FIELD);
  if (field) {
    field.value = search.place;
  }
  var submit = control(SUBMIT);
  if (submit) {
    submit.click();
  }
}

// The app has drawn something — cards, or the "no results" block that takes their
// place. Either is an answer; waiting only on cards would hang on exactly the
// search a remembered location is most useful for replacing.
function answered() {
  var results = control(RESULTS);
  var empty = control(EMPTY);
  return results !== null && results.children.length > 0 || empty !== null && empty.offsetParent !== null;
}

// Ready when the button we are going to press exists, the field has stopped
// changing under us, and EITHER the app has answered or its grace has run out.
function whenReady(done) {
  var startedAt = Date.now();
  var previous = null;
  var ticks = 0;
  var poll = window.setInterval(function () {
    var place = valueOf(FIELD);
    var waited = Date.now() - startedAt;
    var steady = ticks > 0 && place === previous;
    previous = place;
    ticks += 1;
    if (control(SUBMIT) && steady && (answered() || waited > GRACE)) {
      window.clearInterval(poll);
      done();
    } else if (waited > GRACE * 5) {
      window.clearInterval(poll);
    }
  }, POLL);
}
function initShowroomsRecall() {
  if (!document.querySelector(PAGE)) {
    return;
  }

  // CAPTURE, and that is not decoration. The app binds its own handlers on
  // `document` — the section's script says so where it stops the card's click —
  // so a listener on the bubble phase is at the mercy of whatever they do to the
  // event on the way past. Down the tree nothing has run yet.
  document.addEventListener('click', function (event) {
    var target = event.target.closest ? event.target : null;
    if (!target) {
      return;
    }

    // Saved on the click, not on every keystroke: it is the moment the shopper
    // committed to those words, and the same event the app acts on.
    if (target.closest(SUBMIT)) {
      write(capture());
    }

    // "Show all" clears the search, so it clears the memory of it too —
    // otherwise the next visit would put back what was just dismissed.
    if (target.closest(RESET)) {
      write(null);
    }
  }, true);

  // Enter in the field is a search too, and it never touches the button.
  document.addEventListener('keydown', function (event) {
    var target = event.target.closest ? event.target : null;
    if (event.key === 'Enter' && target && target.closest(FIELD)) {
      write(capture());
    }
  }, true);

  // The net that does not depend on knowing how a search is run. `pagehide`
  // rather than `beforeunload`: it fires for the bfcache too, and it is the one
  // the browsers agree on.
  //
  // Only ever writes a search it can see. An empty field on the way out is not a
  // reason to forget a good one — clearing is what the reset button is for, and
  // that is handled above.
  window.addEventListener('pagehide', function () {
    var search = capture();
    if (search) {
      write(search);
    }
  });

  // And a third net, for a search that neither the button nor Enter announced.
  document.addEventListener('change', function (event) {
    var target = event.target.closest ? event.target : null;
    if (target && target.closest(FIELD)) {
      write(capture());
    }
  }, true);

  // A permanent, one-attribute answer to "did this module load at all". Worth the
  // line: everything here is aimed at DOM that belongs to an app whose source we
  // cannot read, so the first question when it misbehaves is always whether it
  // ran, and it has already cost a round trip to establish once.
  document.documentElement.dataset.teShowroomsRecall = 'on';
  var saved = read();
  if (saved && saved.place) {
    whenReady(function () {
      return restore(saved);
    });
  }
}

/***/ }),

/***/ "./src/js/statement-drift.js":
/*!***********************************!*\
  !*** ./src/js/statement-drift.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initStatementDrift)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Statement drift — publishes how far each statement block has travelled
 * through the viewport, so its two panels can drift their photography against
 * each other as it passes.
 *
 * `--te-statement-drift` runs -1 to 1: -1 with the block's top edge on the
 * bottom of the screen, 0 as it passes the middle, 1 once its bottom edge has
 * left the top. Symmetrical on purpose — it means the images sit at their true
 * crop exactly when the block is centred, which is when it is being read.
 *
 * The property is all this file produces. Which way each panel moves and how
 * far are in _statement.scss, per the entry point's conventions — and it is
 * only the IMAGES that move, never the panels, so the diptych's geometry and
 * its 20px gap are untouched.
 *
 * Written against scroll position for the same reason as the hero's zoom: a CSS
 * scroll-driven animation is not universal yet, and its fallback is no effect
 * rather than a lesser one. One controller for every instance on the page, so
 * two statement blocks are still one listener and one write per frame.
 */
var SELECTOR = '.js-statement-drift';
var StatementDrift = /*#__PURE__*/function () {
  function StatementDrift(sections) {
    _classCallCheck(this, StatementDrift);
    this.sections = Array.from(sections);
    this.queued = false;
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);
  }
  return _createClass(StatementDrift, [{
    key: "start",
    value: function start() {
      window.addEventListener('scroll', this.onScroll, {
        passive: true
      });
      window.addEventListener('resize', this.onScroll, {
        passive: true
      });
      this.update();
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      // Coalesce a burst of scroll events into one write per frame.
      if (!this.queued) {
        this.queued = true;
        window.requestAnimationFrame(this.update);
      }
    }
  }, {
    key: "update",
    value: function update() {
      this.queued = false;
      var viewport = window.innerHeight;
      this.sections.forEach(function (section) {
        var rect = section.getBoundingClientRect();
        // The full pass: from the top edge arriving at the bottom of the screen
        // to the bottom edge leaving the top. Includes the block's own height, so
        // a tall block drifts no faster than a short one.
        var travel = viewport + rect.height;
        var progress = Math.min(Math.max((viewport - rect.top) / travel, 0), 1);
        section.style.setProperty('--te-statement-drift', (progress * 2 - 1).toFixed(4));
      });
    }
  }]);
}();
function initStatementDrift() {
  var sections = document.querySelectorAll(SELECTOR);
  var stillness = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (sections.length > 0 && !stillness.matches) {
    new StatementDrift(sections).start();
  }
}

/***/ }),

/***/ "./src/js/variant-options.js":
/*!***********************************!*\
  !*** ./src/js/variant-options.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   chosenOptions: () => (/* binding */ chosenOptions),
/* harmony export */   isOptionGesture: () => (/* binding */ isOptionGesture),
/* harmony export */   matchVariant: () => (/* binding */ matchVariant),
/* harmony export */   optionNamesFrom: () => (/* binding */ optionNamesFrom),
/* harmony export */   variantsFrom: () => (/* binding */ variantsFrom)
/* harmony export */ });
/**
 * Which variant is selected, worked out from the form.
 *
 * Shared by the quick view and the product page. Both need the same answer and
 * neither can take it from the theme: the theme updates its own hidden select in
 * its own change handler, and there is no ordering guarantee between that and us.
 * Everything needed is already in the DOM — the checked option inputs, and the
 * product's variants as JSON.
 */

// THE TWO GALLERIES NAME THESE DIFFERENTLY, which is why the product page's
// anchoring did nothing for two rounds: the quick view writes
// `data-option="option1"` and the product page writes `data-option="Colour"` — the
// option's NAME. Parsing a position out of the latter gives NaN and nothing is
// collected.
//
// So this keeps whatever the attribute says and lets the matcher resolve it. A
// map, not an array: the key is the attribute's own value, and only the matcher
// needs to know what that means.
function chosenOptions(form) {
  var chosen = {};
  form.querySelectorAll('[data-option]').forEach(function (input) {
    var key = input.getAttribute('data-option');
    var picked = input.type === 'radio' ? input.checked : true;
    if (picked && key) {
      chosen[key] = input.value;
    }
  });
  return chosen;
}

// Resolves each option position against both naming schemes: `option1`-style
// first, then the option's name from the product's own `options` list. Either
// gallery lands on the same variant.
function matchVariant(variants, chosen, optionNames) {
  var names = optionNames || [];
  var keys = Object.keys(chosen);
  return variants.find(function (variant) {
    var options = variant.options || [];
    return keys.length > 0 && options.every(function (value, index) {
      var wanted = chosen["option".concat(index + 1)] !== undefined ? chosen["option".concat(index + 1)] : chosen[names[index]];

      // An option nobody has expressed a preference about does not disqualify a
      // variant — it just is not part of the test.
      return wanted === undefined || wanted === value;
    });
  });
}

// The product's option NAMES, in order, so the matcher can resolve a name-keyed
// control. Present on both payloads — the quick view's is a variants array and the
// product page's is the whole product.
function optionNamesFrom(root, selector) {
  var script = root.querySelector(selector);
  var names = [];
  if (script) {
    try {
      var parsed = JSON.parse(script.textContent);
      names = Array.isArray(parsed) ? [] : parsed.options || [];
    } catch (error) {
      names = [];
    }
  }
  return names;
}

// A malformed payload is not worth breaking a page over — callers get an empty
// list and simply leave the gallery as it is.
function variantsFrom(root, selector) {
  var script = root.querySelector(selector);
  var variants = [];
  if (script) {
    try {
      var parsed = JSON.parse(script.textContent);
      variants = Array.isArray(parsed) ? parsed : parsed.variants || [];
    } catch (error) {
      variants = [];
    }
  }
  return variants;
}

// True only for a shopper's own gesture. The theme dispatches its own change
// against these forms while it is building them, and acting on that moves a
// gallery before anything has been touched.
function isOptionGesture(event, form) {
  var target = event.target;
  return event.isTrusted && form && target.closest('.radio-container, [data-option]') !== null;
}

/***/ }),

/***/ "./src/js/video-gallery.js":
/*!*********************************!*\
  !*** ./src/js/video-gallery.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initVideoGallery)
/* harmony export */ });
/**
 * The video gallery's player — /pages/videos.
 *
 * A `<dialog>` does the modal part itself: `showModal()` traps focus inside it,
 * Escape closes it, the rest of the page goes inert and the backdrop is ours to
 * paint. So this is only the two things the element does not do — putting the
 * right video in the frame, and taking it back out again.
 *
 * THE FRAME IS EMPTY UNTIL ASKED. Seven YouTube embeds on one page is seven
 * players booting on load. The `src` is written on open and cleared on close,
 * which also stops a video carrying on playing behind a dialog that has been
 * dismissed — closing a dialog does not stop what is inside it.
 */
var TRIGGER = '[data-te-video]';
var MODAL = '[data-te-video-modal]';
var FRAME = '[data-te-video-frame]';
var CLOSE = '[data-te-video-close]';
var YOUTUBE_ID = /(?:youtu\.be\/|\/embed\/|[?&]v=)([\w-]{6,})/;

// The three shapes a YouTube URL arrives in — youtu.be/ID, /embed/ID and
// watch?v=ID — are the three the gallery's own blocks are using today. Anything
// else is passed through untouched: a Vimeo embed or a self-hosted file is still
// a URL an iframe can take, and refusing it here would be this module deciding
// what the merchant may link to.
function embedUrl(raw) {
  var match = YOUTUBE_ID.exec(raw);
  var url = raw;
  if (match) {
    url = 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1&rel=0';
  }
  return url;
}
function open(modal, frame, trigger) {
  frame.setAttribute('src', embedUrl(trigger.getAttribute('data-te-video')));
  var title = trigger.getAttribute('data-te-video-title');
  if (title) {
    modal.setAttribute('aria-label', title);
  }
  if (typeof modal.showModal === 'function') {
    modal.showModal();
  }
}
function close(modal, frame) {
  // Emptied rather than paused: there is no cross-origin control over a YouTube
  // iframe without loading their API, and removing the src stops it outright.
  frame.removeAttribute('src');
  if (modal.open) {
    modal.close();
  }
}
function initVideoGallery() {
  var modal = document.querySelector(MODAL);
  var frame = modal ? modal.querySelector(FRAME) : null;
  if (!modal || !frame) {
    return;
  }
  document.addEventListener('click', function (event) {
    var target = event.target.closest ? event.target : null;
    if (!target) {
      return;
    }
    var trigger = target.closest(TRIGGER);
    if (trigger) {
      open(modal, frame, trigger);
      return;
    }
    if (target.closest(CLOSE)) {
      close(modal, frame);
    }
  });

  // A click on the dialog element itself is a click on the backdrop — the inner
  // panel is a child, so anything inside it stops here first.
  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      close(modal, frame);
    }
  });

  // Escape closes the dialog without going through our button, so the frame has
  // to be emptied on the element's own event rather than only in `close`.
  modal.addEventListener('close', function () {
    return frame.removeAttribute('src');
  });
}

/***/ }),

/***/ "./src/scss/custom.scss":
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/theme/assets/custom": 0,
/******/ 			"theme/assets/custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunktileboutique_theme"] = self["webpackChunktileboutique_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["theme/assets/custom"], () => (__webpack_require__("./src/js/custom.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["theme/assets/custom"], () => (__webpack_require__("./src/scss/custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;